import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Mail, Phone, MapPin } from "lucide-react";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);

    emailjs
      .send(
        "service_1q8d5jl",   // replace with your EmailJS service ID
        "template_hftv7u3",  // replace with your EmailJS template ID
        formData,
        "Y9ax5LQiP7dy81wqz"    // replace with your EmailJS public key
      )
      .then(
        () => {
          setSuccess("✅ Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setSuccess("❌ Failed to send message. Try again.");
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <main className="bg-neutral-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-black flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1600&q=80"
            alt="Café Contact"
            className="w-full h-full object-cover opacity-60"
          />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-lg md:text-xl">We’d love to hear from you!</p>
        </div>
      </section>

      {/* Contact Info + Form */}
      <section className="py-16 px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
        {/* Info Section */}
        <div>
          <h2 className="text-3xl font-bold mb-6">Get in Touch</h2>
          <p className="text-gray-700 mb-4">
            Have a question, want to book a table, or just say hello?  
            Reach us through the details below.
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Mail className="text-amber-600" />
              <a href="mailto:info@svkdigital.com" className="hover:underline">
                info@svkdigital.com
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="text-amber-600" />
              <a href="tel:+919495083895" className="hover:underline">
                +91 94950 83895
              </a>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="text-amber-600" />
              <span>UrbanEdge Café, Downtown City</span>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white p-8 rounded-2xl shadow-lg">
          <h3 className="text-2xl font-semibold mb-6">Send us a Message</h3>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-amber-500 outline-none"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-amber-500 outline-none"
              required
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Your Message"
              className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-amber-500 outline-none"
              required
            ></textarea>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-lg transition"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
          {success && (
            <p className="mt-4 text-center font-medium text-gray-700">{success}</p>
          )}
        </div>
      </section>

      {/* Map Section */}
      <section className="h-[50vh]">
        <iframe
          title="UrbanEdge Café Location"
          src="https://maps.google.com/maps?q=kochi%20kerala&t=&z=13&ie=UTF8&iwloc=&output=embed"
          className="w-full h-full border-0"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>
    </main>
  );
};

export default Contact;
